import { type ReactNode } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { useCategoryTreeAccess } from '../hooks'

/**
 * Route guard: only renders the categories page for users the feature is enabled for.
 * Everyone else is redirected to the dashboard, so a direct /categories URL reveals nothing.
 */
export function RequireCategoryTree({ children }: { children: ReactNode }) {
  const { orgId } = useParams()
  const access = useCategoryTreeAccess()

  if (access.isLoading) return null
  if (access.data?.enabled !== true) {
    return <Navigate to={orgId ? `/o/${orgId}/dashboard` : '/'} replace />
  }
  return <>{children}</>
}
